import { useEffect } from 'react';

import { datadogLogs } from '@datadog/browser-logs';
import { datadogRum } from '@datadog/browser-rum';
import { reactPlugin } from '@datadog/browser-rum-react';

export const useInitDatadog = () => {
  useEffect(() => {
    datadogRum.init({
      applicationId: 'c7d873ce-372c-4f83-b1cf-c83869987d53',
      clientToken: 'pub0712aaa8586240d737b9416781bdccdb',
      site: 'datadoghq.com',
      service: 'aqxtrader-web',
      env: 'prod',
      version: '3.7.2-1a90d87e8',
      allowedTracingUrls: [
        (url) => {
          const urlObj = new URL(url);
          return urlObj.host === window.location.host;
        }
      ],
      traceSampleRate: 25,
      sessionSampleRate: 25,
      sessionReplaySampleRate: 20,
      trackUserInteractions: true,
      trackResources: true,
      trackLongTasks: true,
      trackSessionAcrossSubdomains: true,
      defaultPrivacyLevel: 'mask-user-input',
      plugins: [reactPlugin({ router: false })]
    });

    datadogLogs.init({
      clientToken: 'pub5f3861d788b5e70f5a5aca95560eb0a2',
      site: 'datadoghq.com',
      forwardErrorsToLogs: true,
      sessionSampleRate: 25
    });
  }, []);
};
